import React, { useState } from 'react'
import { Dialog, DialogContent, Button, Tooltip, DialogActions } from "@material-ui/core"
import QueueIcon from '@material-ui/icons/Queue';
import {generateID} from "../middleware/employeeList"
import { Link } from "react-router-dom";

function GenerateID(props) {
    const {email,employeelist,employeeid} = props
    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleGenerate = () => {
        generateID(email)
        handleClose()
    }

    if(!employeeid)
        return (
            <div>
                <Tooltip title="Generate ID">
                    <Link style={{ color: "red", paddingLeft: "5px", paddingRight: "5px"}} onClick={handleClickOpen}><QueueIcon size={20} /></Link>
                </Tooltip>

                <Dialog
                    onClose={handleClose}
                    fullWidth
                    aria-labelledby="customized-dialog-title"
                    open={open}
                >
                    <DialogContent dividers>
                        <div style={{fontWeight: "500",fontSize: "medium"}}>
                        You are about to generate an ID for <span style={{fontWeight: "bolder"}}>{email}</span> ?
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={handleClose}
                            variant="contained"
                            color="secondary"
                        >
                            Cancel
                        </Button>
                        <Button
                            onClick={handleGenerate}
                            variant="contained"
                            color="primary"
                        >
                            Generate
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        )
    return(<></>)
}

export default GenerateID